// 9fbef606107a605d69c0edbcd8029e5d
import getLoyaltyBenefits from '@tcp/core/src/queries/getLoyaltyBenefits.query.graphql';
import CacheConfiguration from '@tcp/core/src/services/handler/graphQL/clients/retryConfiguration';
import logger from '@tcp/core/src/utils/loggerInstance';
import { executeStatefulGraphQLQuery } from '../../handler';

export const getLoyaltyTierBenefits = (cacheTTL, skipCache = false) => {
  const { preFix, defaultTTL } = CacheConfiguration?.GET_LOYALTY_BENEFITS;

  return executeStatefulGraphQLQuery({
    query: getLoyaltyBenefits,
    cacheConfigKey: `${preFix}`,
    TTL: cacheTTL || defaultTTL,
    fetchPolicy: skipCache ? 'network-only' : '',
  })
    .then((res) => {
      return res?.data?.getLoyaltyBenefits;
    })
    .catch((error) => {
      logger.error('Error fetching tier benefits', error);
      throw new Error('There is some error in fetching tier benefits');
    });
};

export default {
  getLoyaltyTierBenefits,
};
